import { useState, useEffect } from 'react';
import {
  ISMTPAccountsResponse,
  WorkspaceLogoDTO,
  getDefaultWorkspaceLogo,
  getRecruiterSMTPAccounts,
} from 'wisestep-api';

import { getFile } from '../../features/careerPageSettings/util';

export const useSurveyLogoUrl = () => {
  const [fileUrl, setFileUrl] = useState<string>('');

  useEffect(() => {
    const fetchSurveyLogoUrl = async () => {
      const logoResponse = await getDefaultWorkspaceLogo('LOGO');
      if (logoResponse.data) {
        const logoDetails: WorkspaceLogoDTO = logoResponse.data;
        const url = await getFile(logoDetails.s3Url.split('?')[0]);
        setFileUrl(url);
      }
    };

    fetchSurveyLogoUrl();
  }, []);

  return fileUrl;
};

export const useDefaultSmtpEmail = () => {
  const [defaultSmtpEmailValue, setDefaultSmtpEmailValue] = useState<string | undefined>('');
  const [showEmailPopupFlag, setShowEmailPopupFlag] = useState<boolean>(false);
  const [preferredProviderId, setPreferredProviderId] = useState<string>('');

  useEffect(() => {
    const fetchSmtpAccount = async () => {
      const smtpResponse = await getRecruiterSMTPAccounts();
      if (smtpResponse?.data) {
        const allEmails: ISMTPAccountsResponse[] = smtpResponse.data;
        let defaultEmail = allEmails.find((email) => email.isDefault);
        if (allEmails.length === 0) {
          setShowEmailPopupFlag(true);
        } else if (!defaultEmail) {
          defaultEmail = allEmails[0];
        }
        setDefaultSmtpEmailValue(defaultEmail?.fromEmail);
        setPreferredProviderId(defaultEmail?.id ?? '');
      }
    };
    fetchSmtpAccount();
  }, []);

  return {
    defaultSmtpEmailValue,
    showEmailPopupFlag,
    preferredProviderId,
  };
};
